export enum OrientationOnRect {
  VERTICAL = 0,
  HORIZONTAL = 1,
}
